export default "__VITE_ASSET__7xejkfe4__"